import type { Pagination } from 'models';
import { useEffect, useState } from 'react';
import { useChannelsEventsInfiniteQuery } from '../../../queries';
import type { ChannelsEventsListFilter } from '../../../types';

// TODO: rename
// TODO: now this hook can be only used in places where we need channels events query with event slim response
export const useEvents = ({
  allowUnfeatured,
  filter,
  pagination,
}: {
  allowUnfeatured?: boolean;
  filter?: ChannelsEventsListFilter;
  pagination: Omit<Pagination, 'position'>;
}) => {
  const [isFeatured, setIsFeatured] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsFeatured(true);
  }, [filter?.organizationId]);

  const query = useChannelsEventsInfiniteQuery({
    filter: { ...filter, featured: isFeatured },
    pagination,
  });

  useEffect(() => {
    if (isFeatured && allowUnfeatured && query.data?.pages[0]?.length === 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsFeatured(false);
    }
  }, [isFeatured, allowUnfeatured, query.data?.pages]);

  return { isFeatured, query };
};
